<template>
    <div class="right-frame-outer">
        <b-icon-chevron-double-right
            class="openRightSidebarBtn green"
            variant="default"
            font-scale="1.2"
            :class="!opened ? 'closed' : ''"
            @click="opened = !opened; $emit('rightFrameOpen', opened)"
        ></b-icon-chevron-double-right>
        <div class="right-frame-container" :class="!opened ? 'hideSidebar' : ''">
            <div class="right-frame">
                <div class="item">
                    <div class="flex space-between items-center mb-2">
                        <p class="title m-0">Sinteză proiect</p>
                        <div class="currency-select buget">
                            <span class="currency-picker" :class="selectedCurrency === '€' ? 'selected' : ''" @click="selectedCurrency = '€'">€</span>
                            <span class="currency-picker" :class="selectedCurrency === 'L' ? 'selected' : ''" @click="selectedCurrency = 'L'">L</span>
                        </div>
                    </div>
                    <p class="item-title">Buget total proiect</p>
                    <div v-if="selectedCurrency === '€'" class="flex buget">
                        <span class="currency">€</span>
                        <span>{{ formatPrice(statistics.total.EUR) }}</span>
                    </div>
                    <div v-else class="flex buget">
                        <span class="currency">L</span>
                        <span>{{ formatPrice(statistics.total.RON) }}</span>
                    </div>
                </div>
                <div class="item">
                    <p class="item-title space-between"><span class="percent">{{ statistics.total_eligibil_proiect.procent }}%</span>Total eligibil proiect</p>
                    <div v-if="selectedCurrency === '€'" class="flex buget">
                        <span class="currency">€</span>
                        <span>{{ formatPrice(statistics.total_eligibil_proiect.EUR) }}</span>
                    </div>
                    <div v-else class="flex buget">
                        <span class="currency">L</span>
                        <span>{{ formatPrice(statistics.total_eligibil_proiect.RON) }}</span>
                    </div>
                </div>
                <div class="item">
                    <p class="item-title space-between"><span class="percent green">{{ statistics.nerambursabil.procent }}%</span>Nerambursabil</p>
                    <div v-if="selectedCurrency === '€'" class="flex buget">
                        <span class="currency">€</span>
                        <span :class="statistics.nerambursabil.EUR > maxBudget ? 'red blinker' : ''">{{ formatPrice(statistics.nerambursabil.EUR) }}</span>
                    </div>
                    <div v-else class="flex buget">
                        <span class="currency">L</span>
                        <span :class="statistics.nerambursabil.EUR > maxBudget ? 'red blinker' : ''">{{ formatPrice(statistics.nerambursabil.RON) }}</span>
                    </div>
                    <div class="flex buget">
                        <span class="currency">&nbsp;&nbsp;&nbsp;</span>
                        <div class="flex flex-column">
                            <span v-if="selectedCurrency === '€'" class="yellow-text">{{ maxBudget ? maxBudget.toLocaleString('ro-RO') : 0 }}</span>
                            <span v-else class="yellow-text">{{ maxBudget ? (maxBudget * 4.946).toLocaleString('ro-RO') : 0 }}</span>
                            <span class="yellow-text smaller-text">({{ checkPercentageOfTotal() > 0 ? checkPercentageOfTotal() : 0 }}% / maxim)</span>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <p class="item-title space-between"><span class="percent green">{{ statistics.cofinantare_eligibila.procent }}%</span>Cofinanțare eligibilă</p>
                    <div v-if="selectedCurrency === '€'" class="flex buget">
                        <span class="currency">€</span>
                        <span>{{ formatPrice(statistics.cofinantare_eligibila.EUR) }}</span>
                    </div>
                    <div v-else class="flex buget">
                        <span class="currency">L</span>
                        <span>{{ formatPrice(statistics.cofinantare_eligibila.RON) }}</span>
                    </div>
                </div>
                <div class="item">
                    <p class="item-title space-between"><span class="percent green">{{ statistics.cheltuieli_neeligibile.procent }}%</span>Cheltuieli neeligibile</p>
                    <div v-if="selectedCurrency === '€'" class="flex buget">
                        <span class="currency">€</span>
                        <span>{{ formatPrice(statistics.cheltuieli_neeligibile.EUR) }}</span>
                    </div>
                    <div v-else class="flex buget">
                        <span class="currency">L</span>
                        <span>{{ formatPrice(statistics.cheltuieli_neeligibile.RON) }}</span>
                    </div>
                </div>
                <div class="right-items mt-2">
                    <ul>
                        <li>Scăderea CA  <span class="divider">•</span> <span class="points green">{{ statistics.scadere_ca }}</span></li>
						<li>CAEN negativ (INS)  <span class="divider">•</span> <span class="points green">{{ statistics.caen_negativ }}</span></li>
						<li>Creșterea productivității
							<span class="divider">•</span>
							<span class="points">{{ statistics.cresterea_productivitatii }}</span>
						</li>
						<div class="dotted-spacer"></div>
						<li class="yellow">
							Produs / proces inovativ
							<span class="divider">•</span>
							<span class="points yellow">
								{{ statistics.produs_inovativ }}
							</span>
						</li>
						<li class="yellow">Investiții obiective mediu  <span class="divider">•</span>
							<span class="points yellow">
								{{ statistics.investitii_mediu }}
							</span>
						</li>
                    </ul>
                </div>
               <div class="dotted-spacer"></div>
               <div>
                    <ul class="flex space-between align-center m-1">
<!--                        <li>Pondere % echipamente <span class="divider">•</span> <span class="points yellow">{{ statistics.equipment_percentage && statistics.equipment_percentage.procent ? statistics.equipment_percentage.procent.toFixed(1) : 0 }}</span></li>-->
<!--                        <li>Locuri de muncă create <span class="divider">•</span> <span class="points yellow">{{ statistics.employees ? statistics.employees : 0 }}</span></li>-->
                        <li class="text-white"><strong style="font-size: 23px;">55</strong> pct
                            <i v-if="isFiftyFivePointsChecked" class="fas fa-check green"></i>
                            <i v-else class="fas fa-times yellow"></i>
                        </li>
                        <li class="text-white"><strong style="font-size: 23px;">70</strong> pct
                            <i v-if="isSeventyPointsChecked" class="fas fa-check green"></i>
                            <i v-else class="fas fa-times yellow"></i>
                        </li>
                    </ul>
                </div>
<!--                <div class="right-items">-->
<!--                    <ul class="m-0">-->
<!--&lt;!&ndash;                        <li>Pondere % echipamente <span class="divider">•</span> <span class="points yellow">{{ statistics.equipment_percentage && statistics.equipment_percentage.procent ? statistics.equipment_percentage.procent.toFixed(1) : 0 }}</span></li>&ndash;&gt;-->
<!--                        <li>Locuri de muncă create <span class="divider">•</span> <span class="points yellow">{{ statistics.employees ? statistics.employees : 0 }}</span></li>-->
<!--                    </ul>-->
<!--                </div>-->
                <div class="dotted-spacer"></div>
                <div class="flex space-between align-center mt-1">
                    <div class="action">
                        <b-icon-trash
                            font-scale="1.3"
                            style="margin-right: 15px; color: #fff;"
                            @click="modalShow = ! modalShow"
                        ></b-icon-trash>
                        <span style="font-size: 11px;" @click="modalShow = ! modalShow">Șterge proiect</span>
                        <b-modal
                            id="blackModal"
                            v-model="modalShow"
                            button-size="md"
                            ok-variant="success"
                            ok-title="Confirmă"
                            cancel-variant="danger"
                            cancel-title="Anulează"
                            header-bg-variant="dark"
                            body-bg-variant="dark"
                            hide-header-close
                            centered
                            @ok="deleteCompany"
                        >
                            <DeleteM3Company></DeleteM3Company>
                        </b-modal>
                    </div>
                    <div class="action">
                        <b-icon-files
                            font-scale="1.3"
                            style="margin-right: 15px; color: #fff;"
                            @click="modalShow2 = ! modalShow2"
                        ></b-icon-files>
                        <span style="font-size: 11px;" @click="modalShow2 = ! modalShow2">Duplică proiect</span>
                        <b-modal
                            id="blackModal"
                            v-model="modalShow2"
                            button-size="md"
                            ok-variant="success"
                            ok-title="Confirmă"
                            cancel-variant="danger"
                            cancel-title="Anulează"
                            header-bg-variant="dark"
                            body-bg-variant="dark"
                            hide-header-close
                            centered
                            @ok="duplicateCompany"
                        >
                            <DuplicateM3Company @selectedSections="selectedSections = $event"></DuplicateM3Company>
                        </b-modal>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {BModal, BIconTrash, BIconFiles, BIconChevronDoubleRight} from 'bootstrap-vue'
    import DeleteM3Company from "./DeleteM3Company";
    import DuplicateM3Company from "./DuplicateM3Company";
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';

    export default {
        components: {
            BModal,
            BIconTrash,
            BIconFiles,
            DeleteM3Company,
            DuplicateM3Company,
            BIconChevronDoubleRight
        },

        props: {
            activeCompany: null,
        },

        data() {
            return {
                opened: false,
                selectedCurrency: '€',
                modalShow: false,
                modalShow2: false,
                ca: 0,
                selectedSections: [],
                statistics: {
                    total: {
                        RON: 0,
                        EUR: 0
                    },
                    total_eligibil_proiect: {
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    cofinantare_eligibila: {
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    cheltuieli_neeligibile: {
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    },
                    nerambursabil: {
                        RON: 0,
                        EUR: 0,
                        procent: 0
                    }
                }
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData'];
            },
            getStatistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
            turnover() {
                return this.allData ? this.allData.turnover : null;
            },
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            isFiftyFivePointsChecked() {
                return this.statistics.scadere_ca + this.statistics.caen_negativ + this.statistics.cresterea_productivitatii == 55;
            },
            isSeventyPointsChecked() {
                return this.statistics.scadere_ca + this.statistics.caen_negativ + this.statistics.cresterea_productivitatii +
                    this.statistics.produs_inovativ + this.statistics.investitii_mediu > 70;
            }
        },
        watch: {
            getStatistics: {
                handler () {
                    if(this.getStatistics){
                        this.statistics = this.getStatistics
                        this.$forceUpdate();
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                this.opened = window.innerWidth >= 1400;
            })
            this.opened = window.innerWidth >= 1400;
        },
        methods: {
            deleteCompany() {
                axios.delete(api.API_ENDPOINTS.m3company + this.activeCompany)
                    .then(response => {
                        this.$toast.success(response.data.message);
                        this.$store.dispatch('pageLoading/setLoading', true)
                        localStorage.removeItem('currentM3Company')
                        localStorage.removeItem('checks')
                        this.$store.dispatch('checks/resetChecks')
                        this.$store.dispatch('stateAids/removeAids')
                        this.$store.dispatch('m3Sketch/setM3Company', null)
                        localStorage.removeItem('currentM3CompanyId')
                        axios.get(api.API_ENDPOINTS.m3company)
                            .then(response => {
                                this.$store.dispatch('m3Sketch/setCompanies', response.data)
                                if(response.data.length > 0) {
                                    let company = response.data.slice(-1).pop();
                                    localStorage.setItem('currentM3Company', JSON.stringify(company))
                                    this.$store.dispatch('m3Sketch/setM3Company', company)
                                    this.$store.dispatch('m3Sketch/initializeAllData')
                                    this.$store.dispatch('m3Sketch/initializeIndicators').then(() => {
                                        this.$store.dispatch('pageLoading/setLoading', false)
                                    })
                                    this.$emit('changeCompany', company)
                                } else {
                                    location.href = api.MY_ACCOUNT_ROUTE
                                }
                            })
                    })
            },

            duplicateCompany() {
                let url = api.MY_ACCOUNT_ROUTE + '?duplicate=' + this.activeCompany

                if(this.selectedSections.length){
                    url = url + '&sections='
                    this.selectedSections.forEach(section => {
                        url = url + section + ','
                    })
                    url = url.slice(0, -1);
                }

                location.href = url;
            },

            formatPrice(price) {
                price = price.toString().replace('.', ',');
                var pattern = /(-?\d+)(\d{3})/;
                while (pattern.test(price))
                    price = price.replace(pattern, "$1.$2");
                return price;
            },
            checkPercentageOfTotal() {
                return (this.statistics.nerambursabil.EUR / this.maxBudget*100).toFixed(0)
            }
        }
    }
</script>

<style>
#blackModal >>> .modal-footer{
    background: #343a40;
}
</style>
<style scoped>
    .red{
        color: #eb8a9d!important;
    }
    .blinker{
        animation: blinker 1.2s cubic-bezier(.5, 0, 1, 1) infinite alternate;
    }
    .right-frame {
        background: linear-gradient(to bottom, #69586e, #22686c);
        width: 258px;
        padding: 20px 20px 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100%;
    }
    .right-frame-container {
        height: 100%;
        overflow-y: auto;
        transition: .5s;
    }
	.right-frame-outer{
		height: calc(100vh - 167px);
	}
    .openRightSidebarBtn {
        position: absolute;
        right: 20px;
        margin-top: 5px;
        cursor: pointer;
        transition: .5s;
        color: #fff;
        z-index: 1;
    }

    .closed {
        transform: rotate(180deg);
    }

    .hideSidebar {
        margin-right: -260px !important;
    }

    .smaller-text{
        font-size: 10px !important;
        margin-top: -5px;
    }
    .yellow-text{
        color: #ffc44d !important;
    }
    .title {
        font-size: 17px;
        margin-bottom: 20px;
        color: #ffffff;
        font-weight: 600;
        text-align: center;
    }
    .items-center{
        align-items: center;
    }

    .flex {
        display: flex;
    }

    .item {
        margin-bottom: 10px;
    }

    .item-title {
        color: #f0f0f0;
        font-size: 12px;
        text-align: right;
        position: relative;
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }

    .space-between {
        justify-content: space-between !important;
    }

    .item-title:before {
        position: absolute;
        content: '';
        height: 1px;
        background: transparent;
        border-bottom: 2px dotted #fff;
        width: 90%;
        right: -20px;
        bottom: -5px;
        opacity: 0.3;
    }
    .dotted-spacer{
        margin: 8px 0;
        height: 2px;
        width: 100%;
        border-bottom: 2px dotted #fff;
        opacity: 0.3;
    }
    .buget span {
        color: #cfc3cf;
        font-size: 20px;
        font-weight: 400;
    }

    .buget .currency, .buget .currency-picker {
        font-weight: 600;
        color: #ffffff;
        margin-right: 10px;
    }

    .selected{
        border-bottom: 2px solid #00ffd2;
    }

    .currency-picker{
        cursor: pointer;
    }

    .percent {
        font-size: 14px;
        font-weight: 600;
    }

    .green {
        color: #00ffd2;
    }

    .right-items ul {
        list-style: none;
        text-align: right;
    }

    .right-items li {
        font-size: 12px;
        color: #fff;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .right-items li:not(:last-child){
        margin-bottom: 8px;
    }

    .points {
        font-size: 16px;
        font-weight: 500;
        color: #fff;
        display: inline-block;
        min-width: 23px;
        text-align: center;
    }

    .divider {
        padding: 0 10px;
    }

    .align-center {
        align-items: center;
    }

    .yellow {
        color: #ffc44d !important;
    }

    .action {
        max-width: 100px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .action span {
        font-size: 12px;
		line-height: 15px;
        color: #fff;
        cursor: pointer;
    }

    .fas {
        margin: 5px;
        font-size: 12px;
    }
    @media screen and (max-width: 1537px) {
		.right-frame .title {
			font-size: 15px;
		}
		.right-frame .item {
			margin-bottom: 3px;
		}
		.right-frame .item .item-title {
			margin-bottom: 5px;
		}
		.right-frame .item .item-title .percent {
			font-size: 12px;
		}
		.right-frame .item .buget span {
			font-size: 16px;
		}
		.right-items li:not(:last-child) {
			margin-bottom: 4px;
		}
		.right-items.mt-2 {
			margin-top: 0 !important;
		}
		.right-items ul {
			margin-bottom: 0;
		}
    }
    @media screen and (max-width: 1024px) {
        .right-frame-container .item,
        .right-frame-container .item .item-title{
            margin-bottom: 5px;
        }
    }
</style>
